import { SquarePen } from "lucide-react";
import { useCurrencyStore } from "../store/currencyStore";

export default function ExchangeRateTable() {
    const { currencies } = useCurrencyStore();

    return (
        <div className="w-full bg-card p-4 rounded-lg shadow text-white overflow-x-auto">
            <table className="w-full table-auto border-collapse">
                <thead>
                    <tr className="text-left border-b border-gray-700">
                        <th className="px-4 py-2">Currency</th>
                        <th className="px-4 py-2">Base Rate</th>
                        <th className="px-4 py-2">Final Rate</th>
                        <th className="px-4 py-2">24h Change</th>
                        <th className="px-4 py-2">Status</th>
                        <th className="px-4 py-2">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {currencies.map((currency: any) => (
                        <tr
                            key={currency.currency}
                            className="border-b border-gray-800 hover:bg-gray-900"
                        >
                            <td className="px-4 py-2">{currency.currency}</td>
                            <td className="px-4 py-2">{currency.rate}</td>
                            <td className="px-4 py-2">{currency.rate}</td>
                            <td className="px-4 py-2">+2%</td>
                            <td className="px-4 py-2">Active</td>
                            <td className="px-4 py-2">
                                <SquarePen className="cursor-pointer" />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
